/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect, useState } from "react";
import { formatShortDate } from "~/tools";

type DateRange = {
  from: string;
  to: string;
};

// This is a workaround for a problem with date input from keyboard, we cannot dynamically parse incomplete input date because it will be constantly reset to the full year
// E.g. User starts typing "12/12/1", the incomplete 0001-12-12 date will be parsed into `1901-12-12` ISO format, making it impossible to enter desired year
export function useDateValues(range?: DateRange) {
  const [startDate, setStartDate] = useState(formatShortDate(range?.from));
  const [endDate, setEndDate] = useState(formatShortDate(range?.to));

  useEffect(() => {
    setStartDate(formatShortDate(range?.from));
  }, [range?.from]);

  useEffect(() => {
    setEndDate(formatShortDate(range?.to));
  }, [range?.to]);

  return { startDate, setStartDate, endDate, setEndDate };
}
